import * as React from 'react';
import {
  Checkbox,
  Col,
  Form,
  Input,
  InputNumber,
  Layout,
  Row,
  Select,
  Spin,
  Table,
  Typography,
  message,
} from 'antd';
import PdButton from 'components/pd-button';
import { errHandling } from 'utils';
import Expand from 'react-expand-animated';
import Up from 'components/icons/up';
import Down from 'components/icons/down';
import api from 'services/fee';


const { Content } = Layout;
const { Title } = Typography;

export function Fee() {
  const [form] = Form.useForm();

  const [updateDelivery, setUpdateDelivery] = React.useState(-1);

  const [loadingButton, setLoadingButton] = React.useState(false);
  const [areas, setAreas] = React.useState([]);
  const [provinces, setProvinces] = React.useState([]);
  const [selectedArea, setSelectedArea] = React.useState([]);
  const [validateArea, setValidateArea] = React.useState([]);

  // state for show hide city & district
  const [showCities, setShowCities] = React.useState([]);
  const [showDistrict, setShowDistrict] = React.useState([]);

  const [loadingCity, setLoadingCity] = React.useState(false);

  // function for show hide district
  const handleShowCities = React.useCallback(
    (value) => {
      const currentIndex = showCities.indexOf(value);
      const newChecked = [...showCities];

      if (currentIndex === -1) {
        newChecked.push(value);
      } else {
        newChecked.splice(currentIndex, 1);
      }

      setShowCities(newChecked);
    },
    [showCities]
  );

  // function for show hide district
  const handleShowDistrict = React.useCallback(
    (value) => {
      const currentIndex = showDistrict.indexOf(value);
      const newChecked = [...showDistrict];

      if (currentIndex === -1) {
        newChecked.push(value);
      } else {
        newChecked.splice(currentIndex, 1);
      }

      setShowDistrict(newChecked);
    },
    [showDistrict]
  );

  const handleSelectedArea = React.useCallback(
    (value) => {
      const currentIndex = selectedArea.findIndex(
        (area) => area.id === value.id
      );
      let newChecked = [...selectedArea];

      if (currentIndex === -1) {
        newChecked.push(value);
      } else {
        newChecked.splice(currentIndex, 1);
      }

      // remove child area level when parent level selected
      const haveSelectedDistrict = newChecked.findIndex((area) => area.cityId);
      const haveSelectedCity = newChecked.findIndex((area) => area.provinceId);

      if (!value.cityId && haveSelectedDistrict !== -1) {
        newChecked = newChecked.filter((area) => area.cityId !== value.id);
      }

      if (!value.provinceId && haveSelectedCity !== -1) {
        newChecked = newChecked.filter((area) => area.provinceId !== value.id);
      }

      setSelectedArea(newChecked);
    },
    [selectedArea]
  );

  function hasErrors() {
    const errors = form.getFieldsError();
    return errors.some(({ errors }) => errors.length > 0);
  }

  const handleInputNumberParser = (value) =>
    value.replace(/[^0-9]\s?|(\.*)/g, '');

  const handleInputNumberFormatter = (value) =>
    `Rp ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

  const columns = [
    {
      title: '',
      dataIndex: 'id',
      key: 'id',
      /* eslint-disable react/display-name */
      render: (data) => (
        <Checkbox
          checked
          onClick={() => {
            setSelectedArea((prev) => prev.filter((d) => d.id !== data));
          }}
        />
      ),
    },
    {
      title: 'Transport Fee Area',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Transport Fee',
      key: 'acumatica_id',
      /* eslint-disable react/display-name */
      render: (data, _record, index) => {
        return (
          <div className="rule-form">
            <InputNumber
              className="inputForm input"
              value={selectedArea[index].transport_fee}
              formatter={handleInputNumberFormatter}
              min={0}
              onChange={(value) => {
                const newselectedArea = [...selectedArea];
                newselectedArea[index].transport_fee = value;
                setSelectedArea(newselectedArea);
              }}
              parser={handleInputNumberParser}
              placeholder="Transport Fee"
              step={1}
            />
            <div
              style={{
                color: 'red',
              }}>
              {validateArea[data.id] &&
              validateArea[data.id].transport_fee
                ? validateArea[data.id].transport_fee
                : ''}
            </div>
          </div>
        );
      },
    },
  ];

  async function handleSubmit(values) {
    const payload = {
      delivery_fee: values,
    };
    try {
      if (updateDelivery > 0) {
        await api.updateDelivery(payload, updateDelivery);
        message.success('Successfully update delivery fee!');
      } else {
        await api.publishDelivery(payload);
        message.success('Successfully create delivery fee!');
      }
    } catch (err) {
      errHandling(err);
    } finally {
      setLoadingButton(false);
    }
  }

  const submitTransportFee = async () => {
    const error = {};

    selectedArea.forEach((area) => {
      error[area.id] = {};

      if (!area.transport_fee && area.transport_fee !== 0) {
        error[area.id].transport_fee = 'Please input transport fee!';
      }
    });

    setValidateArea(error);

    const allPropertiesAreEmpty = Object.keys(error).every((id) => {
      const properties = Object.keys(error[id]);
      return properties.length === 0;
    });

    if (allPropertiesAreEmpty) {
      const payload = {
        transport_fees: {
          province_ids: selectedArea
            .filter((area) => !area.cityId && !area.provinceId)
            .map((area) => ({
              id: area.id,
              fee: area.transport_fee,
            })),
          city_ids: selectedArea
            .filter((area) => area.provinceId && !area.cityId)
            .map((area) => ({
              id: area.id,
              fee: area.transport_fee,
            })),
          district_ids: selectedArea
            .filter((area) => area.provinceId && area.cityId)
            .map((area) => ({
              id: area.id,
              fee: area.transport_fee,
            })),
        },
      };
      try {
        await api.createTransportFee(payload);
        message.success('Successfully create transport fee!');
      } catch (error) {
        errHandling(error);
      }
    }
  };

  const getProvinces = async () =>
    await api.listProvince().then((res) => setProvinces(res.data.data));

  const getCitiesOfProvince = async (province) => {
    setLoadingCity(true);
    await api
      .listCitiesOfProvince(province.id)
      .then((res) => {
        const currentIndex = areas.findIndex((area) => area.id === province.id);
        let newData = [...areas];

        if (currentIndex === -1) {
          newData.push(res.data.data);
        }

        setAreas(newData);
      })
      .finally(() => setLoadingCity(false));
  };

  const getDelivery = async () =>
    await api.deliveryFees().then((res) => {
      if (res.data.data.length > 0) {
        setUpdateDelivery(res.data.data[0].id);
        form.setFieldsValue({
          title: res.data.data[0].title,
          fee: Number(res.data.data[0].fee),
        });
      }
    });

  const getTransportFee = async () =>
    await api.listTransportFee().then((res) => {
      const areas = [];
      res.data.data.forEach((area) => {
        if (area.district_id) {
          areas.push({
            id: area.district_id,
            title: area.district.name,
            transport_fee: area.fee,
            cityId: area.city_id,
            provinceId: area.province_id,
          });
        } else if (area.city_id) {
          areas.push({
            id: area.city_id,
            title: area.city.title,
            transport_fee: area.fee,
            provinceId: area.province_id,
          });
        } else {
          areas.push({
            id: area.province_id,
            title: area.province.title,
            transport_fee: area.fee,
          });
        }
      });
      setSelectedArea(areas);
    });

  React.useEffect(() => {
    getDelivery();
    getTransportFee();
    getProvinces();
    // eslint-disable-next-line
  }, []);

  return (
    <Layout className="pd-cms-fee main-container">
      <div className="container">
        <div className="content">
          <div className="pageTitle">Fee Management</div>
          <Content>
            <Form form={form} onFinish={handleSubmit} layout='vertical'>
              <div className="section-container">
                <div className="inner-section">
                  <Title className="pageSubtitle" level={3}>
                    Delivery Fee
                  </Title>
                  <Row>
                    <Col span={12}>
                      <Form.Item
                        label="Delivery Name"
                        name="title"
                        rules={[
                          {
                            required: true,
                            message: 'Please input delivery name!',
                          },
                        ]}>
                        <Input placeholder="Standard (2-3 Hari)" />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={12}>
                      <Form.Item
                        label="Delivery Fee"
                        name="fee"
                        rules={[
                          {
                            required: true,
                            message: 'Please input delivery fee!',
                          },
                        ]}>
                        <InputNumber
                          className="inputForm input"
                          formatter={handleInputNumberFormatter}
                          parser={handleInputNumberParser}
                          placeholder="Transport Fee"
                          step={1}
                          min={0}
                          style={{ width: '100%' }}
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Form.Item wrapperCol={{ span: 4, offset: 20 }}>
                    <div className="buttonSection mt-3">
                      <PdButton
                        disabled={hasErrors()}
                        full
                        htmlType="submit"
                        loading={loadingButton}
                        type="primary">
                        Publish
                      </PdButton>
                    </div>
                  </Form.Item>
                </div>
              </div>
            </Form>

            <div className="section-container">
              <div className="inner-section">
                <Title className="pageSubtitle" level={3}>
                  Transport Fee
                </Title>
                <Row gutter={[16, 32]}>
                  <Col span={12}>
                    <Select
                      mode="multiple"
                      style={{ width: '100%' }}
                      placeholder="Please select"
                      onDeselect={(value) => {
                        const newselectedArea = selectedArea.filter(
                          (area) => area.id !== Number(value)
                        );
                        setSelectedArea(newselectedArea);
                      }}
                      value={selectedArea.map((area) => area.id.toString())}
                      dropdownRender={() => {
                        return (
                          <div
                            style={{
                              maxHeight: 250,
                              overflowY: 'scroll',
                              display: 'flex',
                              flexDirection: 'column',
                              gap: 16,
                              padding: 16,
                            }}>
                            {provinces.map((province) => (
                              <div
                                onMouseDown={(e) => e.preventDefault()}
                                key={province.id}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleShowCities(province.id);
                                  if (showCities.indexOf(province.id) === -1) {
                                    getCitiesOfProvince(province);
                                  } else {
                                    let newData = [...areas];
                                    const currentIndex = areas.findIndex(
                                      (area) => area.id === province.id
                                    );
                                    newData.splice(currentIndex, 1);
                                    setAreas(newData);
                                  }
                                }}>
                                <div
                                  style={{
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                  }}>
                                  <div
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: 12,
                                    }}>
                                    <Checkbox
                                      onChange={() => {
                                        handleSelectedArea({
                                          id: province.id,
                                          title: province.title,
                                        });
                                      }}
                                      checked={
                                        selectedArea.findIndex(
                                          (area) => area.id === province.id
                                        ) !== -1
                                      }
                                      onClick={(e) => e.stopPropagation()}
                                    />
                                    {province.title}
                                  </div>
                                  {showCities.indexOf(province.id) === -1 ? (
                                    <Down />
                                  ) : (
                                    <Up />
                                  )}
                                </div>

                                {loadingCity ? (
                                  <>
                                    {showCities.indexOf(province.id) !== -1 && (
                                      <div
                                        style={{
                                          display: 'flex',
                                          justifyContent: 'center',
                                          margin: '32px 0px',
                                        }}>
                                        <Spin />
                                      </div>
                                    )}
                                  </>
                                ) : (
                                  <Expand
                                    open={
                                      showCities.indexOf(province.id) !== -1
                                    }>
                                    <div
                                      style={{
                                        padding: '8px 16px 0px',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: 16,
                                      }}>
                                      {areas.length > 0 &&
                                        areas[
                                          showCities.indexOf(province.id) !==
                                            -1 &&
                                            showCities.indexOf(province.id)
                                        ] &&
                                        areas[
                                          showCities.indexOf(province.id) !==
                                            -1 &&
                                            showCities.indexOf(province.id)
                                        ].cities.map((city) => (
                                          <div
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              handleShowDistrict(city.id);
                                            }}
                                            key={city.id}>
                                            <div
                                              style={{
                                                cursor: 'pointer',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                              }}>
                                              <div
                                                style={{
                                                  display: 'flex',
                                                  alignItems: 'center',
                                                  gap: 12,
                                                }}>
                                                <Checkbox
                                                  onChange={() => {
                                                    handleSelectedArea({
                                                      id: city.id,
                                                      title: city.title,
                                                      provinceId: province.id,
                                                    });
                                                  }}
                                                  checked={
                                                    selectedArea.findIndex(
                                                      (area) =>
                                                        area.id === province.id
                                                    ) !== -1 ||
                                                    selectedArea.findIndex(
                                                      (area) =>
                                                        area.id === city.id
                                                    ) !== -1
                                                  }
                                                  disabled={
                                                    selectedArea.findIndex(
                                                      (area) =>
                                                        area.id === province.id
                                                    ) !== -1
                                                  }
                                                  onClick={(e) =>
                                                    e.stopPropagation()
                                                  }
                                                />
                                                {city.title}
                                              </div>
                                              {showDistrict.indexOf(city.id) ===
                                              -1 ? (
                                                <Down />
                                              ) : (
                                                <Up />
                                              )}
                                            </div>
                                            <Expand
                                              open={
                                                showDistrict.indexOf(
                                                  city.id
                                                ) !== -1
                                              }>
                                              <div
                                                style={{
                                                  padding: '8px 16px 0px',
                                                  display: 'flex',
                                                  flexDirection: 'column',
                                                  gap: 16,
                                                }}>
                                                {city.districts.map(
                                                  (district) => (
                                                    <div
                                                      style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: 12,
                                                        cursor: 'pointer',
                                                      }}
                                                      key={district.id}>
                                                      <Checkbox
                                                        onChange={() =>
                                                          handleSelectedArea({
                                                            id: district.id,
                                                            title:
                                                              district.name,
                                                            provinceId:
                                                              province.id,
                                                            cityId: city.id,
                                                          })
                                                        }
                                                        checked={
                                                          selectedArea.findIndex(
                                                            (area) =>
                                                              area.id ===
                                                              province.id
                                                          ) !== -1 ||
                                                          selectedArea.findIndex(
                                                            (area) =>
                                                              area.id ===
                                                              city.id
                                                          ) !== -1 ||
                                                          selectedArea.findIndex(
                                                            (area) =>
                                                              area.id ===
                                                              district.id
                                                          ) !== -1
                                                        }
                                                        disabled={
                                                          selectedArea.findIndex(
                                                            (area) =>
                                                              area.id ===
                                                              province.id
                                                          ) !== -1 ||
                                                          selectedArea.findIndex(
                                                            (area) =>
                                                              area.id ===
                                                              city.id
                                                          ) !== -1
                                                        }
                                                        onClick={(e) =>
                                                          e.stopPropagation()
                                                        }
                                                      />
                                                      {district.name}
                                                    </div>
                                                  )
                                                )}
                                              </div>
                                            </Expand>
                                          </div>
                                        ))}
                                    </div>
                                  </Expand>
                                )}
                              </div>
                            ))}
                          </div>
                        );
                      }}
                      optionLabelProp="label"
                      tagRender={({value, onClose}) => {
                        const area = selectedArea.find((a) => a.id.toString() === value);
                        return (
                          <span
                            style={{
                              marginRight: 3,
                              display: 'inline-flex',
                              alignItems: 'center',
                              padding: '4px 8px',
                              background: '#f5f5f5',
                              borderRadius: 4,
                            }}>
                            {area?.title || value}
                            <span
                              style={{ marginLeft: 4, cursor: 'pointer' }}
                              onClick={onClose}>
                              ×
                            </span>
                          </span>
                        );
                      }}></Select>
                  </Col>
                  <Col span={24}>
                    <Table
                      dataSource={selectedArea}
                      columns={columns}
                      pagination={false}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col span={4} offset={20}>
                    <PdButton full type="primary" className='mt-3' onClick={submitTransportFee}>
                      Publish
                    </PdButton>
                  </Col>
                </Row>
              </div>
            </div>
          </Content>
        </div>
      </div>
    </Layout>
  );
}
